export enum SupportedCalendarsEnum {
  GOOGLE = 'GOOGLE',
  OFFICE365 = 'OFFICE365',
  OUTLOOK_LIVE = 'OUTLOOK_LIVE'
}
